import { api as wiredApi } from './index';

/**
 * The free riders near a point, for the client's home map (InGo ADR 0036):
 * each an hourly key, a vehicle, a blurred position, a heading and an age,
 * never who. Built from its client so a test can hand it a fake.
 */
export function createNearby({ api }) {
  return {
    /** `GET customer/me/nearby-riders`: nearest first, at most twelve. */
    async around(latitude, longitude) {
      const { data } = await api.get('/customer/me/nearby-riders', { query: { latitude, longitude } });

      return Array.isArray(data) ? data : [];
    },
  };
}

export const nearbyApi = createNearby({ api: wiredApi });
